export default function Project(props){
    let project = props.project;
    return <li className={props.active ? 'project active' : 'project'} >
            <button className="show" onClick={() => props.setSelectedProject({id: project.id, name: project.project})} >{project.project}</button>
            <button className="info" onClick={() => props.showProject(project.id)}><i className="las la-info-circle"></i></button>
    </li>
}